async function getUserClaims(user, uid, setUserRecord) {
  const targetUrl = `${process.env.CMS_URL}/user-permissions/cucc?targetuid=${uid}`;

  let resData;
  const token = await user.getIdToken();
  try {
    const res = await fetch(targetUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    resData = await res.json();
  } catch (error) {
    console.log("error", error);
  }

  setUserRecord(resData);
}

export default getUserClaims;
